import {
  Anagha_Sivadas,
  Hanna_Salam,
  Hemanth_R,
  Nayana_Vinod,
  Nikita_menon,
  Shimil,
  Sony_P,
  TomVempala,
  Vishruth_Subramanian,
} from "../assets/team/teamImages";

const coreData = [
  {
    id: 1,
    name: "Sony P",
    title: "Faculty Advisor",
    image: Sony_P,
    linkedIn: "",
  },

  {
    id: 2,
    name: "Vishruth S",
    title: "Chairperson",
    image: Vishruth_Subramanian,
    linkedIn: "https://www.linkedin.com/in/vishruth-subramanian/",
  },
  {
    id: 3,
    name: "Nayana Vinod",
    title: "Vice-Chairperson",
    image: Nayana_Vinod,
    linkedIn: "https://www.linkedin.com/in/nayana-vinod",
  },
  {
    id: 4,
    name: "Tom Thomas",
    title: "CP Head",
    image: TomVempala,
    linkedIn: "https://www.linkedin.com/in/tom-vempala-6175ab175/",
  },
  {
    id: 5,
    name: "Anagha Sivadas",
    title: "Events Head",
    image: Anagha_Sivadas,
    linkedIn: "https://www.linkedin.com/in/anagha-sivadas",
  },
  {
    id: 6,
    name: "Hanna Salam",
    title: "Outreach Head",
    image: Hanna_Salam,
    linkedIn: "https://www.linkedin.com/in/hanna-salam",
  },
  {
    id: 7,
    name: "Shimil Abraham",
    title: "Design Head",
    image: Shimil,
    linkedIn: "https://www.linkedin.com/in/shimil-abraham-47049a1b6",
  },
  {
    id: 8,
    name: "Hemanth R",
    title: "Tech Head",
    image: Hemanth_R,
    linkedIn: "https://www.linkedin.com/in/hhhrrrttt222111/",
  },
  {
    id: 9,
    name: "Nikita Menon",
    title: "Content Head",
    image: Nikita_menon,
    linkedIn: "https://www.linkedin.com/in/nikita-menon-b2248079",
  },
];

export default coreData;
